/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVolumeOff: {
  name: 'volume-off';
  data: string;
} = {
  name: 'volume-off',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.838 4.316C16.16 3.37 18 4.316 18 5.943v12.334c0 1.535-1.659 2.498-2.992 1.736L9.734 17H6a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h3.68l5.158-3.684ZM16 5.943l-5.158 3.684A2 2 0 0 1 9.68 10H6v5h3.734a2 2 0 0 1 .993.264L16 18.276V5.943Z" fill="currentColor"/></svg>`,
};
